import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';
import { getAppSession } from './session';
import { redirect } from '@tanstack/react-router';
import { toastKeys } from '~/util/types/toasts';

const logoutSchema = z.object({
    showToast: z.enum(toastKeys).optional().catch(undefined),
    redirectTo: z.string().optional(),
    send_toast: z.boolean().optional().default(false),
});

export const logoutServer = createServerFn()
    .validator(logoutSchema)
    .handler(async (context) => {
        const { showToast, redirectTo } = context.data;

        const session = await getAppSession();
        await session.clear();

        if (redirectTo)
            throw redirect({
                to: redirectTo,
                search: { showToast },
            });
    });
